import { render, staticRenderFns } from "./frmsaleinvoice.vue?vue&type=template&id=cb5f6858&scoped=true&"
import script from "./frmsaleinvoice.vue?vue&type=script&lang=js&"
export * from "./frmsaleinvoice.vue?vue&type=script&lang=js&"
import style0 from "./frmsaleinvoice.vue?vue&type=style&index=0&id=cb5f6858&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb5f6858",
  null
  
)

export default component.exports